<template>
  <a
    @click.prevent="onClickQuiz"
    class="button outlined task-quiz"
  >{{ $c( quizStarted ? 'Продолжить игру' : 'Играть' ) }}</a>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
const randomRewards = namespace('randomRewards')
@Component({
  components: {}
})
class Quiz extends Vue {
  @randomRewards.Action('startQuiz') startQuiz
  @randomRewards.State('quizStarted') quizStarted
  onClickQuiz () {
    this.$root.$emit('randomRewardsOpenQuiz')
    setTimeout(this.startQuiz, 300)
  }
}
export default Quiz
</script>
<style lang="scss">
.task-quiz {
  .task__completed & {
    pointer-events: none;
    display: none;
  }
}
</style>
